import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';
import { useEffect, useMemo, useState } from 'react';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';
import sleep from 'sleep-promise';
import { useDispatch } from 'react-redux';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';

function List() {

    const profileFilter = chooseProfileFilter(); 
    const pathFrontEnd = '/governanceroom/neighborhoods/';
    const paths = { 
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}governanceroom/neighborhoods/delete`,
        endpointGroups: `${config.endpoints.backend}governanceroom/groups/getall`,
        endpointSubGroups: `${config.endpoints.backend}governanceroom/subgroups/getall`,
        endpointCities: `${config.endpoints.backend}governanceroom/cities/getall`,
        endpoint: `${config.endpoints.backend}governanceroom/neighborhoods/getall`
    };

    const dispatch = useDispatch();
    const [filterValues, setFilterValues] = useState({});

    const handleChange = async (element) => {
        const target = element['target'];
        let filters = {...filterValues}
        if(target.name === 'governance_room_city_id'){
            filters.governance_room_group_id = '';
            filters.governance_room_sub_group_id = '';
        }
        if(target.name === 'governance_room_group_id'){
            filters.governance_room_sub_group_id = '';
        }
        filters = {...filters, [target['name']]: target['value']}
        setFilterValues(filters)
        await sleep(1000);
        dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
    };

    useEffect(() => {
        async function fetchSubGroups (){
            await sleep(500);
            dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
        }

        fetchSubGroups();
    }, [filterValues])

    const filters = useMemo(() => ({
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        update_key: `${filterValues.governance_room_city_id}-${filterValues.governance_room_group_id}-${filterValues.governance_room_sub_group_id}`,
        handleSubmit: loadData,
        fields: [
            {
                name: 'neighborhood_name',
                type: 'text',
                label: 'Bairro',
                handleChange,
                validations: {
                  required: false
                },
                columnSize: 4
            },
            {
                name: 'governance_room_city_id',
                type: 'select',
                label: 'Município',
                handleChange,
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointCities,
                    label: 'city_name',
                    value: 'id',
                    params: {
                        filter: {
                            where: {
                                profileFilter
                            }
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4
            },
            {
                name: 'governance_room_group_id',
                type: 'select',
                label: 'Grupo',
                handleChange,
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGroups,
                    label: 'description',
                    value: 'id',
                    params: {
                        filter: {
                            governance_room_city_id: filterValues.governance_room_city_id,
                            profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4
            },
            {
                name: 'governance_room_sub_group_id',
                type: 'select',
                label: 'Sub-Grupo',
                handleChange,
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointSubGroups,
                    label: 'description',
                    value: 'id',
                    params: {
                        filter: {
                            governance_room_city_id: filterValues.governance_room_city_id,
                            governance_room_group_id: filterValues.governance_room_group_id,
                            profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4
            }
        ],
        values: {
            governance_room_group_id: filterValues.governance_room_group_id,
            governance_room_sub_group_id: filterValues.governance_room_sub_group_id,
            governance_room_city_id: filterValues.governance_room_city_id,
            neighborhood_name: filterValues.neighborhood_name
        }
    }), [filterValues]);
    
    const list = useMemo(() => {
        let list = {
            labelTitle: 'Bairros',
            labelTitleButtonAdd: 'Novo Bairro',
            showPrintButtons: false,
            formFilters: filters,
            fieldsShowOnDelete: ['description'],
            filter:{
                governance_room_group_id: filterValues.governance_room_group_id,
                governance_room_sub_group_id: filterValues.governance_room_sub_group_id,
                governance_room_city_id: filterValues.governance_room_city_id,
                neighborhood_name: filterValues.neighborhood_name,
                profileFilter
            },
            columns: [
                {
                    name: 'city_state_name',
                    label: 'Cidade',
                    width: '25%'
                },
                {
                    name: 'group_name',
                    label: 'Grupo',
                    width: '25%'
                },{
                    name: 'sub_group_name',
                    label: 'Sub-Grupo',
                    width: '25%'
                },
                {
                    name: 'description',
                    label: 'Bairro',
                    width: '20%'
                },
            ],
        };
        list = {...list, ...paths};

        return list;
    }, [filterValues]);

    const content = useMemo(() => (
        <CustomList list={{ ...list, ...paths }} />
    ), [list, filters]);

    const customListContainer = useMemo(() => (
    <CustomListContainer
        pathAdd={paths.pathAdd}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={content}
    />
    ), [content, list, filters]);
    
    return (
        <div>
            {customListContainer}
        </div>
    );
}
export default List;